import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux"; // Redux'tan veri almak için kullanılır

const Navdata = () => {
  const history = useNavigate();
  
  const storedUserData = sessionStorage.getItem("authUserData");
  const userData = storedUserData ? JSON.parse(storedUserData) : {};
  const isAdmin = userData?.type === "ADMIN";

  const subscriptions = useSelector(state => state.getPermissionsList.subscriptions);  
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isLanding, setIsLanding] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Profile");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [history, iscurrentState, isApps, isAuth, isPages, isBaseUi]);

  const hasFeature = (subscriptionType, feature) => {
    const subscription = subscriptions?.find(sub => sub.subscriptionType === subscriptionType);
    if (subscription) {
      return true;
    }
    return false;
  };

  const menuItems = [
    {
      label: "pages",
      isHeader: true,
    },

    !hasFeature("BITCOIN", "BITCOIN") && {
      id: "home-page",
      label: "Home",
      link: "/dashboard",
      icon: "bx bx-home fs-22",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
    },

    // Customer Analytics
    (hasFeature("AUDIENCE", "audience") || hasFeature("USER_ANALYTIC", "profile")) && {
      id: "pages",
      label: "Customer Analytics",
      icon: "ri-bar-chart-2-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
      subItems: [
        hasFeature("AUDIENCE", "audience") && {
          id: "audience",
          label: "Audience Analytics",
          link: "/audience",
          parentId: "pages",
        },
        hasFeature("USER_ANALYTIC", "productAnalytics") && {
          id: "productAnalytics",
          label: "Product Analytics",
          link: "/pages-maintenance",
          parentId: "pages",
        },
        hasFeature("USER_ANALYTIC", "profile") && {
          id: "starter",
          label: "User Analytics",
          link: "/profile",
          parentId: "pages",
        },
      ].filter(Boolean), 
    },

    // Customer Growth
    (hasFeature("TARGET_AUDIENCE", "targetAudience") || hasFeature("OOH", "oohLocationAudience") || hasFeature("DMP_DSP_EXPORT", "thirdPartyPlatforms")) && {
      id: "customer-growth",
      label: "Customer Growth",
      icon: "bx bxs-user-plus fs-22",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
      subItems: [
        hasFeature("TARGET_AUDIENCE", "targetAudience") && {
          id: "tagetAudience",
          label: "Target Audience",
          link: "/target-audience",
          parentId: "pages",
        },
        hasFeature("OOH", "oohLocationAudience") && {
          id: "oohLocationAudience",
          label: "OOH Location Audience",
          link: "/ooh-location-audience",
          parentId: "pages",
        },
        hasFeature("DMP_DSP_EXPORT", "thirdPartyPlatforms") && {
          id: "thridPartyPlatforms",
          label: "Connect to 3rd Party Platforms",
          link: "/#",
          parentId: "pages",
          isChildItem: true,
          childItems: [
            hasFeature("DMP_DSP_EXPORT", "adsMGMT") && {
              id: "adsMGMT",
              label: "Ads MGMT",
              link: "/third-party-platforms",
            },
            hasFeature("DMP_DSP_EXPORT", "accountMGMT") && {
              id: "accountMGMT",
              label: "Account MGMT",
              link: "/third-party-platforms-accounts",
            }
          ].filter(Boolean), 
        },
      ].filter(Boolean), 
    },

    // Sales Growth
    hasFeature("SALES_GROWTH", "salesGrowth") && {
      id: "sales-growth",
      label: "Sales Growth",
      icon: "bx bx-package fs-22",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
      subItems: [
        {
          id: "campaignManagement",
          label: "Campaign Management",
          link: "/sales-growth/campaigns",
          parentId: "sales-growth",
        },
        {
          id: "notificationApplications",
          label: "Notification Applications",
          link: "/sales-growth/notification-applications",
          parentId: "sales-growth",
        },
      ],
    },

    // AImee Analytics
    
    isAdmin && {
      id: "aimee-analytics",
      label: "AImee Analytics",
      link: "/aimee-analytics",
      icon: "ri-line-chart-line",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
    },

    isAdmin && {
      id: "admin-analytics",
      label: "Admin Analytics",
      link: "/admin-analytics",
      icon: "ri-pie-chart-line",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
    },

    hasFeature("BITCOIN", "BITCOIN") && {
      id: "bitcoin-analytics",
      label: "Bitcoin Analytics",
      link: "/bitcoin-analytics",
      icon: "ri-bit-coin-line",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("pages");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
    },

    isAdmin && {
      id: "aimee-assistant",
      label: "Aimee Assistant",
      link: "/aimee-assistant",
      icon: "ri-mic-line",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState("aimee-asistan");
        updateIconSidebar(e);
      },
      stateVariables: isPages,
    },
    
  ]
  .filter(Boolean); 

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
